import uuid from '@/util/uuid'

import inventoryItemTypes from '@/config/inventoryItemTypes'

export default ({
  id,
  name,
  type
}) => {
  if (!inventoryItemTypes[type]) {
    throw new Error('Unknown item type "' + type + '"')
  }

  return {
    ...inventoryItemTypes[type],
    id: id || uuid(),
    type
  }
}
